
import React from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function Terms() {
  return (
    <div className="min-h-screen">
      <Header />
      <main className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Page Header */}
          <div className="text-center mb-16">
            <div className="inline-block px-4 py-2 bg-emerald-100 text-emerald-600 rounded-full text-sm font-medium mb-4">
              法务声明
            </div>
            <h1 className="text-4xl font-bold text-gray-900 mb-6">使用条款</h1>
            <p className="text-xl text-gray-600">
              使用我们的网站即表示您同意遵守以下条款和条件
            </p>
          </div>

          {/* Content */}
          <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-8 lg:p-12">
            <div className="prose prose-lg max-w-none">
              <p className="text-gray-700 leading-relaxed mb-8">
                欢迎访问我们的官网。使用我们的网站意味着您已经接受了以下条款和条件。
              </p>

              <div className="space-y-8">
                <div>
                  <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
                    <span className="w-8 h-8 bg-emerald-100 text-emerald-600 rounded-full flex items-center justify-center text-sm font-bold mr-3">1</span>
                    版权保护
                  </h2>
                  <p className="text-gray-700 leading-relaxed">
                    本官网的页面和所有包含其中的信息（除非另有说明）受版权保护。未经我们书面许可，禁止以任何形式复制、传播或以其他方式使用这些信息，否则我们将追究法律责任。
                  </p>
                </div>

                <div>
                  <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
                    <span className="w-8 h-8 bg-emerald-100 text-emerald-600 rounded-full flex items-center justify-center text-sm font-bold mr-3">2</span>
                    信息准确性
                  </h2>
                  <p className="text-gray-700 leading-relaxed">
                    我们尽力确保本官网的准确性和完整性，但无法保证信息的绝对准确性和完整性。本官网的信息可能会随时更新或修改，因此您应定期查看本页以确保自己了解最新的使用条款。
                  </p>
                </div>

                <div>
                  <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
                    <span className="w-8 h-8 bg-emerald-100 text-emerald-600 rounded-full flex items-center justify-center text-sm font-bold mr-3">3</span>
                    个人资料
                  </h2>
                  <p className="text-gray-700 leading-relaxed">
                    在使用本官网的过程中，您可能需要提供个人资料，例如姓名、电子邮件地址、电话号码等。我们承诺不会将这些信息泄露给未经授权的第三方，但我们无法保证您的个人资料不会被未经授权的第三方访问。如果您认为您的个人资料已被未经授权的第三方访问，请立即联系我们，我们将尽力协助您解决问题。
                  </p>
                </div>

                <div>
                  <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
                    <span className="w-8 h-8 bg-emerald-100 text-emerald-600 rounded-full flex items-center justify-center text-sm font-bold mr-3">4</span>
                    免责声明
                  </h2>
                  <p className="text-gray-700 leading-relaxed">
                    我们不承担因使用本官网而导致的任何损失、损害、索赔或要求，包括但不限于直接、间接、特别、附带或惩罚性损害赔偿。此外，我们不承担因不可抗力原因造成的任何损失或损害，包括但不限于电力中断、网络故障、计算机系统故障等。
                  </p>
                </div>

                <div>
                  <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
                    <span className="w-8 h-8 bg-emerald-100 text-emerald-600 rounded-full flex items-center justify-center text-sm font-bold mr-3">5</span>
                    第三方链接
                  </h2>
                  <p className="text-gray-700 leading-relaxed">
                    本官网可能包含到其他网站的链接，这些网站不受我们控制。我们不承担任何因使用这些网站而导致的损失、损害、索赔或要求。
                  </p>
                </div>

                <div>
                  <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
                    <span className="w-8 h-8 bg-emerald-100 text-emerald-600 rounded-full flex items-center justify-center text-sm font-bold mr-3">6</span>
                    法律管辖
                  </h2>
                  <p className="text-gray-700 leading-relaxed">
                    本官网的使用条款受当地法律管辖。如果您不同意任何条款，请不要使用本官网。
                  </p>
                </div>
              </div>

              <div className="mt-12 p-6 bg-emerald-50 rounded-xl border border-emerald-200">
                <div className="flex items-start">
                  <div className="w-6 h-6 bg-emerald-100 rounded-full flex items-center justify-center mr-3 mt-1">
                    <i className="ri-information-line text-emerald-600 text-sm"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-emerald-800 mb-2">重要提醒</h3>
                    <p className="text-emerald-700 text-sm leading-relaxed">
                      这些使用条款可能会在未来的某个时间进行修改，并且我们会在本官网上发布通知。如果您继续使用本官网，则表示您已经接受了新的使用条款。
                    </p>
                  </div>
                </div>
              </div>

              <div className="mt-12 text-center">
                <p className="text-gray-500 text-sm">
                  最后更新时间：{new Date().toLocaleDateString('zh-CN')}
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
